<template>
    <v-card flat class="mb-3">
        <div>
            <v-layout row wrap>
                <v-flex xs12 xl8 offset-xl2>
                    <v-card flat class="mt-3 pa-1" v-if="cleaningInputData">
                        <v-form ref="form">
                            <v-flex xs12 >
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-radio-group class="px-3" v-model="cleaningType" row>
                                            <v-radio label="Konteiners" value="container" />
                                            <v-radio label="Autocisterna" value="tank-car"/>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="cleaningType === 'container'">
                                    <v-flex xs12 md4 >
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="container"
                                                        color="deep-purple accent-3"
                                                        item-text="reg_nr"
                                                        item-value="id"
                                                        :rules="formRules"
                                                        required
                                                        :items="cleaningInputData.containers"
                                                        label="Konteiners"
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddContainerModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot konteineru</span>
                                                </v-tooltip>

                                                <v-dialog v-model="containerModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot konteineru
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-container-modal
                                                                    :companies="cleaningInputData.companies"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 md4  >
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="truck"
                                                        color="deep-purple accent-3"
                                                        item-text="reg_nr"
                                                        item-value="id"
                                                        :items="cleaningInputData.trucks"
                                                        label="Vilcējs"
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddTruckModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot vilcēju</span>
                                                </v-tooltip>

                                                <v-dialog v-model="truckModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot vilcēju
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-vehicle-modal :companies="cleaningInputData.companies"
                                                                               :vehicleType="1"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 md4  >
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="trailer"
                                                        color="deep-purple accent-3"
                                                        item-text="reg_nr"
                                                        item-value="id"
                                                        :items="cleaningInputData.trailers"
                                                        label="Piekabe"
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddTrailerModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot piekabi</span>
                                                </v-tooltip>

                                                <v-dialog v-model="trailerModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot piekabi
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-vehicle-modal :companies="cleaningInputData.companies"
                                                                               :vehicleType="2"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap v-if="cleaningType === 'tank-car'">
                                    <v-flex xs12 md6>
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="truck"
                                                        color="deep-purple accent-3"
                                                        item-text="reg_nr"
                                                        item-value="id"
                                                        :items="cleaningInputData.trucks"
                                                        label="Vilcējs"
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddTruckModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot vilcēju</span>
                                                </v-tooltip>

                                                <v-dialog v-model="truckModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot vilcēju
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-vehicle-modal :companies="cleaningInputData.companies"
                                                                               :vehicleType="1"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="tankCar"
                                                        color="deep-purple accent-3"
                                                        item-text="reg_nr"
                                                        item-value="id"
                                                        :items="cleaningInputData.tankCars"
                                                        label="Cisterna"
                                                        :rules="formRules"
                                                        required
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddTankCarModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot cisternu</span>
                                                </v-tooltip>

                                                <v-dialog v-model="tankCarModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot cisternu
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-vehicle-modal :companies="cleaningInputData.companies"
                                                                               :vehicleType="3"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-select
                                                class="pa-3"
                                                v-model="tankCompartments"
                                                color="deep-purple accent-3"
                                                :items="compartments"
                                                label="Sekcijas"
                                        />
                                    </v-flex>

                                    <v-flex xs12 md4>
                                        <v-layout row wrap align-center>
                                            <v-flex xs10>
                                                <v-autocomplete
                                                        clearable
                                                        class="pa-3"
                                                        v-model="cargo"
                                                        color="deep-purple accent-3"
                                                        item-text="name"
                                                        item-value="id"
                                                        :items="cleaningInputData.cargos"
                                                        label="Krava"
                                                        :rules="formRules"
                                                        required
                                                />
                                            </v-flex>

                                            <v-flex xs2>
                                                <v-tooltip top>
                                                    <v-btn  @click.stop="showAddCargoModal" small flat fab color="" slot="activator">
                                                        <v-icon >add</v-icon>
                                                    </v-btn>
                                                    <span>Pievienot kravu</span>
                                                </v-tooltip>

                                                <v-dialog v-model="cargoModal" max-width="700" persistent>
                                                    <v-card>
                                                        <v-card-title class="headline grey lighten-2" primary-title>
                                                            Pievienot kravu
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <add-cargo-modal :cleaningPrograms="cleaningInputData.cleaningPrograms"/>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

<!--                                    <v-flex xs12 md4>-->
<!--                                        <v-autocomplete-->
<!--                                                clearable-->
<!--                                                class="pa-3"-->
<!--                                                v-model="company"-->
<!--                                                color="deep-purple accent-3"-->
<!--                                                item-text="name"-->
<!--                                                item-value="id"-->
<!--                                                :items="cleaningInputData.companies"-->
<!--                                                label="Klients"-->
<!--                                                :rules="formRules"-->
<!--                                                required-->
<!--                                        ></v-autocomplete>-->

                                        <v-flex xs12 md4>
                                            <v-layout row wrap align-center>
                                                <v-flex xs10>
                                                    <v-autocomplete
                                                            clearable
                                                            class="pa-3"
                                                            v-model="company"
                                                            color="deep-purple accent-3"
                                                            item-text="name"
                                                            item-value="id"
                                                            :items="cleaningInputData.companies"
                                                            label="Klients"
                                                            :rules="formRules"
                                                            required
                                                    />
                                                </v-flex>

                                                <v-flex xs2>
                                                    <v-tooltip top>
                                                        <v-btn  @click.stop="showAddCompanyModal" small flat fab color="" slot="activator">
                                                            <v-icon >add</v-icon>
                                                        </v-btn>
                                                        <span>Pievienot klientu</span>
                                                    </v-tooltip>

                                                    <v-dialog v-model="companyModal" max-width="700" persistent>
                                                        <v-card>
                                                            <v-card-title class="headline grey lighten-2" primary-title>
                                                                Pievienot klientu
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <add-company-modal/>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-dialog>
                                                </v-flex>
                                            </v-layout>

                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>

                                    <v-flex xs12 md4 >
                                            <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            class="pa-3"
                                                            v-model="cleaningDate"
                                                            label="Mazgāšanas datums"
                                                            prepend-icon="event"
                                                            readonly
                                                            v-on="on"
                                                            :rules="formRules"
                                                            required
                                                    />
                                                </template>
                                                <v-date-picker v-model="cleaningDate" @input="menu = false"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="startTime"
                                                class="pa-3"
                                                label="Mazgāšana sākta"
                                                color="deep-purple accent-3"
                                                type="time"
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4 >
                                        <v-text-field
                                                v-model="endTime"
                                                class="pa-3"
                                                label="Mazgāšana pabeigta"
                                                color="deep-purple accent-3"
                                                type="time"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-layout row wrap>

                                <v-flex xs12 class="ma-3">
                                    <v-alert
                                            :value="errorStatus"
                                            type="error"
                                    >
                                        {{ errorMessage }}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs6 md3 v-for="option in cleaningInputData.options" :key="option.id">
                                    <v-checkbox class="px-3" color="deep-purple accent-3" v-model="selectedOptions"
                                                :label="option.display_name" :value="option.id"/>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>

                                <v-flex xs12 md4 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="certificateNr"
                                            label="Sertifikāta nr"
                                            color="deep-purple accent-3"
                                    />
                                </v-flex>

                                <v-flex xs12 md4 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="cleaningOrderNr"
                                            label="Iekšējais pasūtījuma nr"
                                            color="deep-purple accent-3"
                                    />
                                </v-flex>

                                <v-flex xs12 md4 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="leftovers"
                                            type="number"
                                            label="Preču paliekas"
                                            color="deep-purple accent-3"
                                    />
                                </v-flex>

                                <v-flex xs12 >
                                    <v-text-field
                                            class="pa-3"
                                            v-model="additionalServices"
                                            label="Piezīmes"
                                            color="deep-purple accent-3"
                                    />
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs12 class="mx-3 mb-3">
                                    <div class="text-xs-center text-md-right">
                                        <v-btn small flat @click="hideAddCleaningForm" dark color="deep-orange lighten-1">
                                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                                            <v-icon dark right>check_circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>

        </div>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddContainerModal from "./AddContainerModal";
    import AddVehicleModal from "./AddVehicleModal";
    import AddCargoModal from "./AddCargoModal";
    import AddCompanyModal from "./AddCompanyModal";

    export default {
        name: "add-cleaning",
        components: {
            AddContainerModal,
            AddVehicleModal,
            AddCargoModal,
            AddCompanyModal
        },
        data: () => ({
            cleaningType:'container',
            container: '',
            truck: '',
            trailer: '',
            tankCar: '',
            company: '',
            cargo: '',
            compartments: [ 1, 2, 3, 4, 5, 6, 7 ],
            cleaningDate: new Date().toISOString().substr(0, 10),
            startTime: '',
            endTime: '',
            selectedOptions: [],
            tankCompartments: 1,
            certificateNr: '',
            additionalServices: '',
            cleaningOrderNr: '',
            leftovers: '',
            menu: false,
            modal: false,
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],

        }),
        created() {
            this.$store.dispatch('resetErrors')
            this.$store.dispatch('getCleaningInputData')
        },
        computed: {
            ...mapGetters({
                cleaningInputData: 'cleaningInputData',
                errorStatus: 'errorStatus',
                errorMessage: 'errorMessage',
                containerModal: 'showAddContainerModal',
                truckModal: 'showTruckModal',
                trailerModal: 'showTrailerModal',
                tankCarModal: 'showTankCarModal',
                cargoModal: 'showCargoModal',
                companyModal: 'showCompanyModal'
            })
        },
        methods: {
            hideAddCleaningForm(){
                this.$store.dispatch('hideAddCleaningForm')
            },
            showAddContainerModal(){
                this.$store.dispatch('showAddContainerModal')
            },
            showAddTruckModal(){
                this.$store.dispatch('showTruckModal')
            },
            showAddTrailerModal(){
                this.$store.dispatch('showTrailerModal')
            },
            showAddTankCarModal(){
                this.$store.dispatch('showTankCarModal')
            },
            showAddCargoModal(){
                this.$store.dispatch('showCargoModal')
            },
            showAddCompanyModal(){
                this.$store.dispatch('showCompanyModal')
            },
            submit(){
                this.$Progress.start()
                if(this.cleaningType === 'container') {
                    if (this.$refs.form.validate()) {
                        this.$store.dispatch('createNewCleaning', {
                            cleaningType: 'Konteiners',
                            cleaningItemId: this.container,
                            truckId: this.truck,
                            trailerId: this.trailer,
                            customerId: this.company,
                            cargoId: this.cargo,
                            cleaningDate: this.cleaningDate,
                            startTime: this.startTime,
                            endTime: this.endTime,
                            options: this.selectedOptions,
                            tankCompartments: this.tankCompartments,
                            certificateNr: this.certificateNr,
                            additionalServices: this.additionalServices,
                            cleaningOrderNr: this.cleaningOrderNr,
                            leftovers: this.leftovers,
                        })
                        this.$parent.snackbar = true
                        this.$parent.color = 'green'
                        this.$parent.text = 'Mazgāšana pievienota'
                    } else {
                        this.$Progress.fail()
                    }
                } else {
                    if (this.$refs.form.validate()) {
                        this.$store.dispatch('createNewCleaning', {
                            cleaningType: 'Cisterna',
                            cleaningItemId: this.tankCar,
                            truckId: this.truck,
                            trailerId: null,
                            customerId: this.company,
                            cargoId: this.cargo,
                            cleaningDate: this.cleaningDate,
                            startTime: this.startTime,
                            endTime: this.endTime,
                            options: this.selectedOptions,
                            tankCompartments: this.tankCompartments,
                            certificateNr: this.certificateNr,
                            additionalServices: this.additionalServices,
                            cleaningOrderNr: this.cleaningOrderNr,
                            leftovers: this.leftovers,

                        })
                        this.$parent.snackbar = true
                        this.$parent.color = 'green'
                        this.$parent.text = 'Mazgāšana pievienota'
                    }
                    else {
                        this.$Progress.fail()
                    }
                }

            },

        }
    }
</script>

<style scoped>

</style>